import { chatConstants } from '../constants'

export const initialState = {
  isOpen: false,
  isAnswerOpen: false,
  isChatOpen: false,
  isLoading: false,
  message: null
}

export default function chat(state = initialState, action) {
  switch (action.type) {
    case chatConstants.TOGGLE_POPUP:
      return {
        isOpen: !state.isOpen
      }
    case chatConstants.TOGGLE_POPUP_ANSWER:
      return {
        isOpen: true,
        isAnswerOpen: !state.isAnswerOpen
      }
    case chatConstants.TOGGLE_SLIDE:
      return {
        isLoading: !state.isLoading,
        isChatOpen: !state.isChatOpen
      }
    case chatConstants.LOAD_REQUEST:
      return {
        isOpen: !state.isOpen,
        isLoading: !state.isLoading
      }
    case chatConstants.LOAD_SUCCESS:
      return {
        isOpen: true,
        isLoading: false,
        message: action.response.data
      }
    default:
      return state
  }
}
